import { fetchFieldViewLayers } from 'layers/loaders';
import { determineApiPrefix } from 'util/env';
import { fieldHealthLayersTags, fieldViewLayerMappings } from 'constants/imagery';
import networkAdapter from '../adapters/network';
import { formatDateForMosaic } from 'util/formatters/dateFormatter';
import { getDynamicTimeoutForManualPrescriptionsZones } from 'util/imagery';

const today = formatDateForMosaic(new Date());

export const fetchFieldViewImagery = ( {userId} ) => {
  // TODO: currently a passthrough because layers and imagery overlay.  Stop that.
  // Also, name is currently misleading - look at that once
  return fetchFieldViewLayers({ userId });
};

export const fetchFieldHealthImageryByFieldId = ({ userId, fieldId, fieldHealthLayer, useV3 }) => {
  if(useV3) {
    const tag = fieldHealthLayersTags[fieldHealthLayer];
    const layer = fieldHealthLayer ? `/fha.${tag}` : '';
    const legacyOptions = {
      url: `/api/mosaic/v3/events/${fieldId}${layer}`,
      userId
    };
    
    return networkAdapter({
      legacyOptions
    });
  }

  const tag = fieldHealthLayersTags[fieldHealthLayer];
  const tagQuery = tag ? `tag=${tag}&` : '';
  const legacyOptions = { // TODO: Unhardcode start-date in url (but mosaic v3 may change this)
    url: `/api/mosaic/v2/image/${fieldId}/veg?${tagQuery}start-date=2010-01-01&end-date=${today}&preview=100&limit=100&order=desc`, // eslint-disable-line max-len
    isPaginatedImagery: true,
    userId
  };

  return networkAdapter({
    legacyOptions
  });
};

export const fetchSsurgoImageryByFieldId = ({ userId, fieldId, useMosaicV4 }) => {
  const url = useMosaicV4
    ? `/api/mosaic/v4/events/${fieldId}/soil?eventDateFrom=2010-01-01&eventDateTo=${today}`
    : `/api/mosaic/v2/image/${fieldId}/soil?start-date=2010-01-01&end-date=${today}&preview=100&limit=100&order=desc`;

  const legacyOptions = {
    url,
    isPaginatedImagery: true,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchSsurgoGeoJson = ( { url, userId } ) => {
  // TODO: requiresOldApiDomain is a hack for S3 redirects - either fix or wait for mosaic v3
  const legacyOptions = {
    url, userId, requiresOldApiDomain: true
  };
  
  return networkAdapter({
    legacyOptions 
  });
};

export const fetchSoilSampleImageryByFieldId = ( {userId, fieldId} ) => {
  const legacyOptions = {
    url: `/api/mosaic/v3/events/${fieldId}/soil.sample`,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchNonSatImageryByFieldId = ({ userId, fieldId }) => {
  const layers = [
    'nonsat.imagery.imported',
    'nonsat.imagery.thermal',
    'nonsat.imagery.chlorophyll',
    'nonsat.imagery.ndvi',
    'nonsat.imagery.cci',
    'nonsat.imagery.waterstress',
    'nonsat.imagery.elevation',
    'nonsat.imagery.rgb'
  ];

  const legacyOptions = {
    url: `/api/mosaic/v3/events/${fieldId}?layers=${layers.join(',')}`,
    userId,
    fieldId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchFieldViewLegend = ({ userId, username, fieldViewUuid, year, crop, layer, fieldViewLayer }) => {
  const subdomain = determineApiPrefix({ requiresFieldViewDomain: true });
  fieldViewLayer = fieldViewLayer || fieldViewLayerMappings[layer];
  const legacyOptions = {
    url: `https:${subdomain}/legend/${username}/${fieldViewUuid}/${year}/${crop}/${fieldViewLayer}/false`,
    userId,
    useClimateAuthHeaders: false,
    redirectsToLoginOnAuthFail: false // if the auth errs, just roll with it.
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchImportedMapsImageryByFieldId = ({ userId, fieldId }) => {
  const legacyOptions = {
    url: `/api/mosaic/v3/events/${fieldId}/imported-map`,
    requiresOldApiDomain: true,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchImportedMapsGeoJson = ({ mapsWithoutGeoJson }) => {
  const timeout = getDynamicTimeoutForManualPrescriptionsZones(mapsWithoutGeoJson.length);
  const geoJsonPromises = mapsWithoutGeoJson
  .map(({ url }) => {
    const path = url.replace(/^.*climate\.com/, '');
    const legacyOptions = {
      url: path,
      requiresOldApiDomain: true,
      useClimateAuthHeaders: false,
      useSameOrigin: true,
      timeout
    };
    return networkAdapter({
      legacyOptions
    });
  });
  return Promise.all(geoJsonPromises);
};
